<template>
  <div>
    <div class="o-flex-cols__row">
      <title-page :title="$t('experiments.titlePage')" />
      <div class="o-flex-cols__row--2col">
        <div class="c-secondary-menu-content__search">
          <search :placeholder="$t('experiments.placeholder')" @changed="onTermChanged" :is-loading="isLoading"/>
          <filters  :on-click="toggleFilters" />
        </div>
      </div>
    </div>

    <transition name="fade">
      <div class="o-flex-cols__row" v-if="isFilterShowed">
        <div class="o-flex-cols__row--1col">
            <div class="c-data-box c-data-box--filters">
                <div class="c-data-content">
                    <div class="c-data-content__data">
                      <experiment-search-filters
                        :on-users-changed="onUserFilterChanged"
                        :on-state-changed="onStateFilterChanged"
                        :on-to-date-changed="onToDateFilterChanged"
                        :on-from-date-changed="onFromDateFilterChanged"
                      />
                    </div>
                </div>
            </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import TitlePage from '@/components/common/TitlePage.vue'
import Search from '@/components/experiments/Search.vue'
import Filters from '@/components/experiments/Filters.vue'
import ExperimentSearchFilters from '@/components/experiments/ExperimentSearchFilters.vue'

export default {
  name: 'HeaderExperiments',
  components: {
    TitlePage,
    Search,
    Filters,
    ExperimentSearchFilters,
  },
  props: {
    onSearchCriteriaChanged: {
      type: Function,
      required: true,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isFilterShowed: false,
      searchCriteria: {
        term: '',
        created_by: [],
        states: '',
        from_date: '',
        to_date: '',
      },
    }
  },
  methods: {
    toggleFilters() {
      this.isFilterShowed = !this.isFilterShowed
    },
    onTermChanged(term) {
      this.searchCriteria.term = term
      this.onSearchCriteriaChanged(this.searchCriteria)
    },
    onUserFilterChanged(event) {
      this.searchCriteria.created_by = event
      this.onSearchCriteriaChanged(this.searchCriteria)
    },
    onStateFilterChanged(event) {
      this.searchCriteria.states = event.join()
      this.onSearchCriteriaChanged(this.searchCriteria)
    },
    onToDateFilterChanged(event) {
      let date = event.target.value

      if (date) {
        date = this.$moment(date, 'YYYY-MM-DD')

        if (date.isValid()) {
          this.searchCriteria.to_date = date.format()
          this.onSearchCriteriaChanged(this.searchCriteria)
        }
      }
    },
    onFromDateFilterChanged(event) {
      let date = event.target.value

      if (date) {
        date = this.$moment(date, 'YYYY-MM-DD')

        if (date.isValid()) {
          this.searchCriteria.from_date = date.format()
          this.onSearchCriteriaChanged(this.searchCriteria)
        }
      }
    },
  },
}
</script>
